export default "__VITE_ASSET__CV2$CF4t__"